import SmartMateriaUITable from '../../generic/SmartMateriaUITable'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'
import { IconButton } from '@mui/material'
import { ManageSearchOutlined } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import { useAuthorization } from '../../generic/hooks/useAuthorization'

const Picklist = () => {
  const { t_ } = useSmartTranslation()
  const navigate = useNavigate()
  const isUserAuthorized = useAuthorization()
  const routeMap = {
    Incidences: '/configuration/picklist/incidence',
    Quality_types: '/configuration/picklist/qualityTypes',
    'Device status': '/configuration/picklist/deviceStatus',
    Reasons: '/configuration/picklist/reasons',
    'Fabrication order status': '/configuration/picklist/fabricationOrderStatus',
    Other_Tasks: '/configuration/picklist/otherTask',
    Order_Status: '/configuration/picklist/orderStatus'
  }

  const columns = [{
    name: t_('Code'),
    field: 'code',
    charLimit: 60,
    mandatory: true,
    unique: true,
    readOnly: (row) => {
      return row.systemDefault
    }
  },
  {
    name: t_('Name'),
    field: 'name',
    charLimit: 80,
    mandatory: true,
    unique: true,
    // The picklists are Jupiter's own fixed list (fetchFunction below): their names and descriptions are literals.
    render: (row) => t_(row.name),
    renderOnlyInReadMode: true,
    readOnly: (row) => {
      return row.systemDefault
    }
  },
  {
    name: t_('Description'),
    field: 'description',
    charLimit: 200,
    render: (row) => t_(row.description),
    renderOnlyInReadMode: true
  }
  ]

  const getPermissionCode = (rowCode) => {
    const permissionMap = {
      DEVICE_STATUS: 'Device status',
      FABRICATION_ORDER_STATUS: 'Fabrication order status',
      INCIDENCES: 'Incidences',
      QUALITY_TYPES: 'Quality_types',
      REASONS: 'Reasons',
      OTHER_TASK: 'Other_Tasks',
      ORDER_STATUS: 'Order_Status',
      ORDER_STATUS_TYPE: 'Order_Status_Type'
    }
    return Object.keys(permissionMap).find(key => permissionMap[key] === rowCode)
  }

  const actions = {
    custom: [
      {
        name: 'View Picklists',
        render: (row) => {
          return (
            <IconButton>
              <ManageSearchOutlined />
            </IconButton>
          )
        },
        disabled: (row) => !isUserAuthorized(getPermissionCode(row.code)),
        onClick: (row) => {
          const route = routeMap[row.code]
          if (route) {
            navigate(route)
          }
        }
      }
    ]
  }

  const fetchFunction = () => {
    const picklists = [
      {
        code: 'Incidences',
        name: 'Incidences',
        description: 'Incidences description'
      },
      {
        code: 'Quality_types',
        name: 'Quality_types',
        description: 'Quality_types description'
      },
      {
        code: 'Device status',
        name: 'Status',
        description: 'Status description'
      },
      {
        code: 'Reasons',
        name: 'Reasons',
        description: 'Reasons description'
      },
      {
        code: 'Fabrication order status',
        name: 'Fabrication order status',
        description: 'Fabrication order status description'
      },
      {
        code: 'Other_Tasks',
        name: 'Other Tasks',
        description: 'OtherTasks description'
      },
      {
        code: 'Order_Status',
        name: 'Order Status',
        description: 'Order status description'
      }
    ]
    return picklists
  }

  return (
    <>
      <SmartMateriaUITable
        tableTuneUniqueKey='picklist'
        columns={columns}
        title={t_('Picklist')}
        dataFetch={fetchFunction}
        actions={actions}
        multipleOptions

      />
    </>
  )
}
export default Picklist
